// Copyright 2020 Participatory Culture Foundation, All Rights Reserved

var $ = require('jquery');
var position = require('./position');

$.behaviors('.amaraTooltip', function(elt) {
  elt = $(elt);
  var target = $('#' + elt.data('target'));
  var overTarget = false, overElt = false, eltVisible = false;

  target.hover(function() {
    overTarget = true;
    updateVisibility();
  }, function() {
    overTarget = false;
    updateVisibility();
  });

  elt.hover(function() {
    overElt = true;
    updateVisibility();
  }, function() {
    overElt = false;
    updateVisibility();
  });

  function updateVisibility() {
    setTimeout(doUpdateVisibility, 100);
  }
  function doUpdateVisibility() {
    var hovering = overTarget || overElt;
    if(hovering && !eltVisible) {
      position.below(target, elt, {dropLeft: true});
      target.fadeIn(200);
      eltVisible = true;
    } else if(!hovering && eltVisible) {
      target.fadeOut(200);
      eltVisible = false;
    }
  }
});
